import React from "react";

export default () => {
  return (
    <svg
      width="189px"
      height="57px"
      viewBox="0 0 131 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Opteon</title>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="app-bar---home" transform="translate(-475.000000, -33.000000)">
          <g id="app-bar">
            <g id="Group-309" transform="translate(475.000000, 33.000000)">
              <path
                d="M32.7369,34.5592 C33.0439,34.5502 33.1389,34.6862 33.1939,34.8992 L33.8219,34.8172 C33.7499,34.3512 33.5109,33.9672 32.7369,33.9672 C32.0229,33.9672 31.5969,34.3972 31.5969,35.1882 C31.5969,35.9792 32.0229,36.4082 32.7369,36.4082 C33.5109,36.4082 33.7499,36.0242 33.8219,35.5582 L33.1939,35.4782 C33.1389,35.6902 33.0439,35.8252 32.7369,35.8172 C32.4159,35.8072 32.2259,35.6132 32.2259,35.1882 C32.2259,34.7632 32.4159,34.5692 32.7369,34.5592 M32.7369,33.3602 C33.7459,33.3602 34.5639,34.1802 34.5639,35.1882 C34.5639,36.1972 33.7459,37.0152 32.7369,37.0152 C31.7289,37.0152 30.9099,36.1972 30.9099,35.1882 C30.9099,34.1802 31.7289,33.3602 32.7369,33.3602"
                id="Fill-265"
                fill="#FFFFFF"
              ></path>
              <path
                d="M41.8596,19.8997 C41.8596,13.7837 44.3736,9.8547 50.4036,9.8547 C56.4346,9.8547 58.9486,13.7837 58.9486,19.8997 C58.9486,26.0167 56.4346,29.9447 50.4036,29.9447 C44.3736,29.9447 41.8596,26.0167 41.8596,19.8997 M45.3266,19.8997 C45.3266,23.5797 46.3276,26.7127 50.4036,26.7127 C54.4816,26.7127 55.4576,23.5797 55.4576,19.8997 C55.4576,16.2197 54.4816,13.0867 50.4036,13.0867 C46.3276,13.0867 45.3266,16.2197 45.3266,19.8997"
                id="Fill-267"
                fill="#FFFFFF"
              ></path>
              <path
                d="M64.3932,28.1794 L64.3932,34.5694 L61.0732,34.5694 L61.0732,19.9744 L60.8522,16.4184 L63.9052,16.4184 L64.1732,18.1104 C65.0272,16.8424 66.3462,16.0714 68.1772,16.0714 C71.8392,16.0714 73.9632,18.5324 73.9632,23.0084 C73.9632,27.4844 71.8392,29.9454 68.1772,29.9454 C66.6152,29.9454 65.2962,29.3984 64.3932,28.1794 M67.4932,19.2534 C65.7852,19.2534 64.6372,20.3734 64.3932,21.4664 L64.3932,24.5494 C64.6372,25.6444 65.7852,26.7624 67.4932,26.7624 C69.2032,26.7624 70.4962,25.5444 70.4962,23.0084 C70.4962,20.4724 69.2032,19.2534 67.4932,19.2534"
                id="Fill-269"
                fill="#FFFFFF"
              ></path>
              <path
                d="M74.7687,16.4187 L77.0627,16.4187 L77.0627,12.9627 L80.3837,12.3167 L80.3837,16.4187 L84.0947,16.4187 L84.0947,19.4777 L80.3837,19.4777 L80.3837,24.4997 C80.3837,26.3397 80.9447,26.7377 82.1417,26.7877 C82.9467,26.8367 83.7047,26.5137 84.0217,26.3397 L84.3387,29.5467 C83.8747,29.7457 83.0687,29.9447 82.0927,29.9447 C77.8687,29.9447 77.0627,27.3587 77.0627,24.6737 L77.0627,19.4777 L74.7687,19.4777 L74.7687,16.4187 Z"
                id="Fill-271"
                fill="#FFFFFF"
              ></path>
              <path
                d="M88.9032,24.3014 C89.0002,26.1664 90.1982,26.9864 91.8582,26.9864 C93.5912,27.0114 94.2502,26.3154 94.4462,25.4194 L97.8392,25.8424 C97.4972,28.0554 96.0572,29.9444 91.9312,29.9444 C87.8042,29.9444 85.3882,27.5084 85.3882,23.0084 C85.3882,18.5074 87.8042,16.0714 91.7602,16.0714 C95.7642,16.0714 97.9122,18.5324 97.9122,23.0084 L97.9122,24.3014 L88.9032,24.3014 Z M88.9272,21.6414 L94.3482,21.6414 C94.2752,19.8754 93.4192,19.0294 91.7842,19.0294 C90.1722,19.0294 89.0982,19.8254 88.9272,21.6414 L88.9272,21.6414 Z"
                id="Fill-273"
                fill="#FFFFFF"
              ></path>
              <path
                d="M99.181,23.0082 C99.181,18.4342 101.622,16.0712 105.529,16.0712 C109.435,16.0712 111.877,18.4342 111.877,23.0082 C111.877,27.5832 109.435,29.9452 105.529,29.9452 C101.622,29.9452 99.181,27.5832 99.181,23.0082 M102.599,23.0082 C102.599,25.7432 103.722,26.7882 105.529,26.7882 C107.335,26.7882 108.458,25.7432 108.458,23.0082 C108.458,20.2732 107.335,19.2292 105.529,19.2292 C103.722,19.2292 102.599,20.2732 102.599,23.0082"
                id="Fill-275"
                fill="#FFFFFF"
              ></path>
              <path
                d="M116.7585,18.1843 C117.6865,16.8663 119.1515,16.0713 120.7865,16.0713 C123.7905,16.0713 125.7925,17.5633 125.7925,20.7203 L125.7925,29.5973 L122.4715,29.5973 L122.4715,21.2173 C122.4715,19.8503 121.5685,19.2533 120.2015,19.2533 C118.5165,19.2533 117.2715,20.4213 116.9535,21.4413 L116.9535,29.5973 L113.6585,29.5973 L113.6585,19.9753 L113.4385,16.4183 L116.4905,16.4183 L116.7585,18.1843 Z"
                id="Fill-277"
                fill="#FFFFFF"
              ></path>
              <path
                d="M129.1249,18.3325 L128.7979,17.3595 L128.7129,17.1035 L128.7209,17.3905 L128.7209,18.3325 L128.1449,18.3325 L128.1449,16.2315 L128.9379,16.2315 L129.2959,17.3055 L129.3899,17.6095 L129.4829,17.3055 L129.8409,16.2315 L130.6349,16.2315 L130.6349,18.3325 L130.0589,18.3325 L130.0589,17.3905 L130.0669,17.1035 L129.9819,17.3595 L129.6549,18.3325 L129.1249,18.3325 Z M127.2889,18.3325 L126.7279,18.3325 L126.7279,16.7675 L126.1139,16.7675 L126.1139,16.2315 L127.9029,16.2315 L127.9029,16.7675 L127.2889,16.7675 L127.2889,18.3325 Z"
                id="Fill-279"
                fill="#FFFFFF"
              ></path>
              <polygon
                id="Fill-281"
                fill="#95B6DF"
                points="17.2914 0.2249 0.0554 10.0499 0.0554 10.0509 17.2914 10.0509"
              ></polygon>
              <polygon
                id="Fill-283"
                fill="#689BD2"
                points="17.2914 10.0506 0.0554 16.5436 17.2914 19.8636"
              ></polygon>
              <polygon
                id="Fill-285"
                fill="#7DA7D8"
                points="0.0558 10.0506 0.0558 16.5436 17.2918 10.0506"
              ></polygon>
              <polygon
                id="Fill-287"
                fill="#0072BC"
                points="17.2914 39.502 0.0554 29.677 0.0554 29.676 17.2914 29.676"
              ></polygon>
              <polygon
                id="Fill-289"
                fill="#2A84C6"
                points="17.2914 29.6763 0.0554 23.1843 17.2914 19.8633"
              ></polygon>
              <polygon
                id="Fill-291"
                fill="#0080C4"
                points="0.0558 29.6763 0.0558 23.1843 17.2918 29.6763"
              ></polygon>
              <polygon
                id="Fill-293"
                fill="#4E8FCC"
                points="0.0558 16.5431 0.0558 23.1841 17.2918 19.8631"
              ></polygon>
              <polygon
                id="Fill-295"
                fill="#DCF2FD"
                points="17.2914 0.2249 34.5274 10.0499 34.5274 10.0509 17.2914 10.0509"
              ></polygon>
              <polygon
                id="Fill-297"
                fill="#9ADBF9"
                points="17.2914 10.0506 34.5274 16.5436 17.2914 19.8636"
              ></polygon>
              <polygon
                id="Fill-299"
                fill="#BCE6FB"
                points="34.5274 10.0506 34.5274 16.5436 17.2914 10.0506"
              ></polygon>
              <polygon
                id="Fill-301"
                fill="#00AEEF"
                points="17.2914 39.502 34.5274 29.677 34.5274 29.676 17.2914 29.676"
              ></polygon>
              <polygon
                id="Fill-303"
                fill="#00C2F3"
                points="17.2914 29.6763 34.5274 23.1843 17.2914 19.8633"
              ></polygon>
              <polygon
                id="Fill-305"
                fill="#00B3F0"
                points="34.5274 29.6763 34.5274 23.1843 17.2914 29.6763"
              ></polygon>
              <polygon
                id="Fill-307"
                fill="#6DCFF6"
                points="34.5274 16.5431 34.5274 23.1841 17.2914 19.8631"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
